(function() {
  var isOpening = false;

  function closeAllDrawers() {
    ['ring-profile-drawer', 'ring-size-drawer'].forEach(function(id) {
      var drawer = document.getElementById(id);
      if (drawer) drawer.classList.remove('is-open');
      var overlay = document.getElementById(id + '-overlay');
      if (overlay) overlay.classList.remove('is-open');
    });
  }

  // --- Band Finishes Drawer ---
  function attachFinishesTrigger() {
    var dropdown = document.getElementById('calc-custom-select-trigger-band_finishes');
    if (!dropdown) return false;

    dropdown.addEventListener('click', function() {
      var drawer = document.getElementById('ring-profile-drawer');
      if (!drawer) return;
      isOpening = true;
      closeAllDrawers();
      drawer.classList.add('is-open');
      var overlay = document.getElementById('ring-profile-drawer-overlay');
      if (overlay) overlay.classList.add('is-open');
      setTimeout(function() { isOpening = false; }, 10);
    });
    return true;
  }

  // --- Ring Size Drawer ---
  function attachSizeTrigger() {
    var dropdown = document.getElementById('calc-custom-select-trigger-ring_size');
    if (!dropdown) return false;

    dropdown.addEventListener('click', function() {
      var drawer = document.getElementById('ring-size-drawer');
      if (!drawer) return;
      isOpening = true;
      closeAllDrawers();
      drawer.classList.add('is-open');
      var overlay = document.getElementById('ring-size-drawer-overlay');
      if (overlay) overlay.classList.add('is-open');
      setTimeout(function() { isOpening = false; }, 10);
    });
    return true;
  }

  // --- Delegated listener ---
  document.addEventListener('click', function(e) {
    // Close if a dropdown option was clicked
    if (e.target.classList.contains('calc-custom-select-option') ||
        e.target.closest('.calc-custom-select-option')) {
      setTimeout(function() { closeAllDrawers(); }, 50);
      return;
    }

    // Outside click to close
    if (isOpening) return;
    ['ring-profile-drawer', 'ring-size-drawer'].forEach(function(id) {
      var drawer = document.getElementById(id);
      if (!drawer) return;
      if (drawer.classList.contains('is-open') && !drawer.contains(e.target)) {
        drawer.classList.remove('is-open');
        var overlay = document.getElementById(id + '-overlay');
        if (overlay) overlay.classList.remove('is-open');
      }
    });
  });

  // --- Poll for elements ---
  var attempts = 0;
  var interval = setInterval(function() {
    attempts++;
    var f = attachFinishesTrigger();
    var s = attachSizeTrigger();
    if ((f && s) || attempts > 40) clearInterval(interval);
  }, 250);

})();


